import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import TablerWrapper from '@components/auntification/tablerWrapper';
import { AUTH_OFFSET_BACK_FORM } from '@components/auntification/tablerWrapper/constants';
import Button from '@components/button/index';
import Input from '@components/input/index';
import Logo from '@components/logo/index';
import { navigateTo, isPhone, Alert, isWeb } from '@helpers';
import { scale } from '@components/frame';
import { resetPassword, userLogin } from '@reducers/user';
import { logOnboarding } from '@reducers/onBoarding';
import { onboardConnector } from '@reducers/onBoarding';
import useStatusBar from '@components/common/useStatusBar';
import ColorsWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import Loading from '@components/loading';

const CreatePassword = ({ route, resetPassword, C, userLogin, onboardConnector, logOnboarding, onBoarding, updateTokenState }) => {
  useStatusBar({ C });

  const data = route?.params?.data || {};
  const title = route?.params?.title;
  const scenario = route?.params?.scenario;
  const isLogin = scenario == 'login';
  const { email } = data;

  const [pass, setPass] = useState('');
  const [loading, setLoading] = useState(false);
  const [globalLoading, setGlobalLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  useEffect(() => {
    if (scenario === 'onBoarding' && !onBoarding?.code) {
      navigateTo('ConnectorSetup');
    }
  }, []);

  const submit = async () => {
    setLoading(true);
    try {
      switch (scenario) {
        case 'password': {
          const { email, code } = data;
          await resetPassword(
            {
              emailAddress: email,
              verificationCode: code,
              confirmedPassword: pass,
              password: pass,
              userProfile: null,
            },
            () => {
              userLogin({ email, pass, callback: isWeb ? updateTokenState : null });
            }
          );
          return;
        }
        case 'login': {
          const { email } = data;
          const result = (await userLogin({ email, pass, callback: isWeb ? updateTokenState : null })) || {};
          if (result.error) {
            setPasswordError(true);
          }
          return;
        }
        case 'onBoarding': {
          setGlobalLoading(true);
          logOnboarding(`Component: Create password. Action: Done`, { ...data, component: 'Create password', action: 'Done' });
          await onboardConnector(
            { ...data, pass },
            true,
            (message) => {
              setGlobalLoading(false);
              Alert({ title: message || 'Something went wrong' });
            },
            updateTokenState
          );
          return;
        }
      }
    } catch (e) {
      console.log(e, 'e');
    } finally {
      setLoading(false);
    }
  };

  if (globalLoading) {
    return (
      <View style={{ width: '100%', flex: 1 }}>
        <Loading />
      </View>
    );
  }

  return (
    <TablerWrapper offset={AUTH_OFFSET_BACK_FORM} keyboardAvoid={!isPhone}>
      <Logo {...{ isBack: true, title: i18n.t(title || 'Enter new password'), withText: false, email }} />
      <View
        style={{
          width: '100%',
          justifyContent: 'center',
          marginBottom: 15,
        }}
      >
        {/* TODO: test it with real iOS device */}
        <Input
          value={email}
          autoComplete="email"
          textContentType="username"
          editable={false}
          importantForAutofill="yes"
          style={{ position: 'absolute', opacity: 0, height: 0 }}
        />
        <Input
          placeholder={i18n.t('Password')}
          errorText="Error"
          onChangeText={setPass}
          value={pass}
          secure={true}
          error={passwordError ? 'Incorrect password Please try again or you can reset your password' : false}
          errorAction={
            passwordError
              ? {
                  text: 'reset your password',
                  action: () => navigateTo('ForgotPass', { email: data?.email }),
                }
              : false
          }
          autoCompleteType="password"
          autoComplete="password"
          autoCapitalize={'none'}
          autoCorrect={false}
          textContentType={'password'}
        />
        <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary'), marginLeft: 16, marginTop: 8 }]}>
          {i18n.t('The minimum password length is 8 characters')}
        </Text>
      </View>
      <Button
        {...{
          name: i18n.t('Done'),
          onPress: submit,
          disabled: !pass || pass.length < 8,
          loading,
        }}
      />
      {isLogin && (
        <View>
          <TouchableOpacity style={{ marginTop: scale(25) }} onPress={() => navigateTo('ForgotPass', { email: data?.email })}>
            <Text style={[{ textAlign: 'center', color: C('Label / Light / Tertiary') }, font['Button 2']]}>{i18n.t('Forgot password')}</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ marginTop: scale(25) }} onPress={() => navigateTo('ScanQR')}>
            <Text style={[{ textAlign: 'center', color: C('Label / Light / Tertiary') }, font['Button 2']]}>
              {i18n.t('Login with QR code instead')}
            </Text>
          </TouchableOpacity>
        </View>
      )}
    </TablerWrapper>
  );
};

export default connect(({ onBoarding }) => ({ onBoarding }), { resetPassword, userLogin, onboardConnector, logOnboarding })(
  ColorsWrapper(CreatePassword)
);
